<template>
  <vs-card>
    <!--div class="vx-row">
      <div class="vx-col w-full">
        <vs-popup
          class="holamundo"
          :title="'Atenção!'"
          :active.sync="form.cpfDuplicado"
          @close="limparCpf"
          button-close-hidden
        >
          Identificamos que esse CPF/CNPJ já encontra-se cadastrado em nossa
          base de dados. (Todos os dados dos outros registros como propostas e
          veículos serão unificados no registro). Caso seja um outro Cadastro,
          informe um novo CPF ou CNPJ.

          <div v-if="this.associadoUnificar">
            <br />
            <br />
            <b>Associado que irá permanecer no sistema: </b>
            <ul>
              <li><b>ID: </b>{{ this.associadoUnificar.id_prospect }}</li>
              <li><b>Nome: </b>{{ this.associadoUnificar.nome }}</li>
              <li><b>CPF/CNPJ: </b>{{ this.associadoUnificar.cpfcnpj }}</li>
              <li><b>Situação: </b>{{ this.associadoUnificar.situacao }}</li>
            </ul>
          </div>

          <div class="mt-6 sm:flex sm:justify-between">
            <vs-button
              class="sm:w-auto w-full mb-4 sm:mb-0"
              @click.stop.prevent="limparCpf"
              color="primary"
              type="filled"
              >Informar outro CPF/CNPJ</vs-button
            >

            <vs-button
              class="sm:w-auto w-full"
              @click.stop.prevent="aceiteUnificarAssociado"
              color="warning"
              type="filled"
              >Unificar Cadastros</vs-button
            >
          </div>
        </vs-popup>
      </div>
    </div-->

    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for="Tipo" class="vs-select--label">Tipo</label>
        <v-select
          :options="tiposPessoas"
          name="Tipo"
          label="label"
          id="Tipo"
          v-model="form.tipo"
          @input="emitChangedForm('tipo', form.tipo)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          :state="validateState('Tipo')"
          :danger="validateClass('Tipo')"
        ></v-select>
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Nome"
          v-model="form.nome"
          name="Nome"
          id="nome"
          @change="emitChangedForm('nome', form.nome)"
          :state="validateState('Nome')"
          :danger="validateClass('Nome')"
        />
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Email"
          v-model="form.email"
          name="Email"
          id="email"
          @change="emitChangedForm('email', form.email)"
          v-validate="{ email: true }"
          :state="validateState('Email')"
          :danger="validateClass('Email')"
        />
      </div>
    </div>

    <div class="vx-row" v-if="form.tipo == 'Pessoa Física'">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="CPF"
          v-mask="'###.###.###-##'"
          autocomplete="off"
          aria-autocomplete="none"
          role="presentation"
          v-model="cpf"
          name="CPF"
          @change="emitChangedForm('cpfcnpj', form.cpfcnpj)"
          v-validate="{ min: 14 }"
          :state="validateState('CPF')"
          :danger="validateClass('CPF')"
          :disabled="!isCpfCanChange($can('Alterar CPF', 'Associados'))"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="RG"
          v-model="form.rgIe"
          name="RG"
          @change="emitChangedForm('rgIe', form.rgIe)"
          :state="validateState('RG')"
          :danger="validateClass('RG')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Nascimento"
          v-mask="'##/##/####'"
          v-model="form.dataNascimento"
          name="Data de Nascimento"
          @change="emitChangedForm('dataNascimento', form.dataNascimento)"
          v-validate="{ date_format: 'dd/MM/yyyy' }"
          :state="validateState('Data de Nascimento')"
          :danger="validateClass('Data de Nascimento')"
        />
      </div>
    </div>
    <div class="vx-row" v-if="form.tipo == 'Pessoa Jurídica'">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNPJ"
          v-mask="'##.###.###/####-##'"
          v-model="cpf"
          autocomplete="off"
          aria-autocomplete="none"
          role="presentation"
          name="CNPJ"
          @change="emitChangedForm('cpfcnpj', form.cpfcnpj)"
          v-validate.immediate="{ min: 18 }"
          :state="validateState('CNPJ')"
          :danger="validateClass('CNPJ')"
          :disabled="!isCpfCanChange($can('Alterar CPF', 'Associados'))"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Inscrição Estadual"
          v-model="form.rgIe"
          name="Inscrição Estadual"
          @change="emitChangedForm('rgIe', form.rgIe)"
          :state="validateState('Inscrição Estadual')"
          :danger="validateClass('Inscrição Estadual')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Representante Legal"
          v-model="form.representanteLegal"
          name="Nome Completo Represente Legal"
          @change="
            emitChangedForm('representanteLegal', form.representanteLegal)
          "
          :state="validateState('Nome Completo Represente Legal')"
          :danger="validateClass('Nome Completo Represente Legal')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Cpf do Representante"
          v-mask="'###.###.###-##'"
          v-model="form.cpfRepresentante"
          name="Cpf do Representante"
          @change="emitChangedForm('cpfRepresentante', form.cpfRepresentante)"
          v-validate="{ min: 14 }"
          :state="validateState('Cpf do Representante')"
          :danger="validateClass('Cpf do Representante')"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Celular"
          v-mask="'(##) #####-####'"
          v-model="form.celular"
          name="Celular"
          id="celular"
          @change="emitChangedForm('celular', form.celular)"
          :state="validateState('Celular')"
          :danger="validateClass('Celular')"
        />
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Celular Adicional"
          v-mask="'(##) #####-####'"
          v-model="form.celularAdicional"
          name="CelularAdicional"
          id="celularAdicional"
          @change="emitChangedForm('celularAdicional', form.celularAdicional)"
          :state="validateState('CelularAdicional')"
          :danger="validateClass('CelularAdicional')"
        />
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Fixo"
          v-mask="'(##) ####-####'"
          v-model="form.telefone"
          name="Telefone"
          id="telefone"
          @change="emitChangedForm('telefone', form.telefone)"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for="Regional" class="vs-select--label">{{
          $t('Regional')
        }}</label>
        <v-select
          :options="regionais"
          name="Regional"
          label="label"
          id="Regional"
          v-model="form.idRegional"
          @input="emitChangedForm('idRegional', form.idRegional)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          :state="validateState(translatedRegional)"
          :danger="validateClass(translatedRegional)"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNH"
          v-mask="'###########'"
          v-model="form.cnh"
          name="CNH"
          id="cnh"
          @change="emitChangedForm('cnh', form.cnh)"
          v-validate="{ min: 11 }"
          :state="validateState('CNH')"
          :danger="validateClass('CNH')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for="Tipo de CNH" class="vs-select--label">Tipo de CNH</label>
        <v-select
          :options="tipoDeCarteira"
          name="Tipo de CNH"
          label="label"
          id="Tipo de CNH"
          v-model="form.catCnh"
          @input="emitChangedForm('catCnh', form.catCnh)"
          class="select-large w-full"
          :reduce="(item) => item.id"
          :state="validateState('Tipo de CNH')"
          :danger="validateClass('Tipo de CNH')"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Vencimento CNH"
          v-mask="'##/##/####'"
          v-model="form.dataVencimentoCnh"
          name="Data de Vencimento CNH"
          id="dataVencimentoCnh"
          @change="emitChangedForm('dataVencimentoCnh', form.dataVencimentoCnh)"
        />
      </div>
    </div>
    <!-- endereço -->
    <h5 class="mt-6">Endereço</h5>
    <hr class="mt-2 mb-3 hr-endereco" />

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CEP"
          v-mask="'##.###-###'"
          v-model="form.cep"
          name="CEP"
          @keyup.native="keymonitor"
          id="cep"
          @change="emitChangedForm('cep', form.cep)"
          v-validate="{ required: true, min: 10 }"
          :state="validateState('CEP')"
          :danger="validateClass('CEP')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Endereço"
          v-model="form.endereco"
          name="Endereço"
          id="endereco"
          @change="emitChangedForm('endereco', form.endereco)"
          v-validate="{ required: true }"
          :state="validateState('Endereço')"
          :danger="validateClass('Endereço')"
        />
      </div>
      <div class="vx-col sm:w-1/6 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número"
          v-model="form.numero"
          name="Número"
          id="numero"
          @change="emitChangedForm('numero', form.numero)"
          v-validate="{ required: true }"
          :state="validateState('Número')"
          :danger="validateClass('Número')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Complemento"
          v-model="form.complemento"
          name="Complemento"
          id="complemento"
          @change="emitChangedForm('complemento', form.complemento)"
          v-validate="{ required: true }"
          :state="validateState('Complemento')"
          :danger="validateClass('Complemento')"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Bairro"
          v-model="form.bairro"
          name="Bairro"
          id="bairro"
          @change="emitChangedForm('bairro', form.bairro)"
          v-validate="{ required: true }"
          :state="validateState('Bairro')"
          :danger="validateClass('Bairro')"
        />
      </div>

      <div
        v-if="usaUF || isInterno"
        :class="`vx-col ${isInterno ? 'sm:w-1/3' : 'sm:w-1/2'} w-1/2 mb-2`"
      >
        <label for="" class="vs-select--label">Estado</label>
        <v-select
          :options="estados"
          name="Estado"
          id="Estado"
          autocomplete="off"
          @input="
            ((abrirSelectCidade = true), (alterouEstado = true)),
              buscaDadosSelectsCidades(
                'domMunicipio',
                'cidades',
                'nomeCidade',
                'idCidade',
              ),
              selecionaEstado()
          "
          v-model="estado"
          v-validate="{ required: true }"
          label="label"
          :state="validateState('Estado')"
          :class="validateClass('Estado')"
        ></v-select>
      </div>

      <div
        v-if="usaUF || isInterno"
        :class="`vx-col ${
          isInterno == true ? 'sm:w-1/3' : 'sm:w-2/2'
        } w-1/2 mb-2`"
      >
        <label for="" class="vs-select--label">Cidade</label>
        <v-select
          :options="cidades"
          name="Cidade"
          id="Cidade"
          @input="selecionaCidade()"
          ref="selectCidade"
          v-model="cidade"
          v-validate="{ required: true }"
          label="label"
          :state="validateState('Cidade')"
          :class="validateClass('Cidade')"
        ></v-select>
      </div>
    </div>
  </vs-card>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import vSelect from 'vue-select';
import { decryptData } from '../../services/decryptData';
import {
  getFromCache,
  saveToCache,
  isValidCachedData,
} from '../../services/cacheService';
import functions from '../../utils/functions';

export default {
  props: ['dadosProposta', 'formulario', 'regionais'],
  watch: {
    dadosProposta() {
      this.preencheForm();
    },
    cpf() {
      if (this.cpf) {
        this.form.cpfcnpj = this.cpf;
      }
    },
    estado(newValue, oldValue) {
      if (this.form.cep) {
        return;
      }
      const isValueChanged = newValue !== oldValue && oldValue !== null;

      if (isValueChanged) {
        this.cidade = null;
        this.form.cidade = null;
        this.resetEndereco(newValue, oldValue);
        const shouldResetDiscount = this.permissaoResetarDesconto;
        if (shouldResetDiscount) {
          this.resetaDesconto();
        }
      }
    },

    cidade(newValue, oldValue) {
      const isValueChanged = newValue !== oldValue;
      const shouldProcessValueChange =
        isValueChanged && oldValue !== null && typeof oldValue === 'string';

      if (shouldProcessValueChange) {
        this.resetEndereco(newValue, oldValue);

        const shouldResetDiscount = this.permissaoResetarDesconto;
        if (shouldResetDiscount) {
          this.resetaDesconto();
        }
      }
    },

    'form.cep': async function (newValue, oldValue) {
      const isLengthTenAndChanged =
        newValue.length === 10 && newValue !== oldValue && oldValue !== null;

      if (isLengthTenAndChanged) {
        const temCepePermissao = this.temCep && this.permissaoResetarDesconto;
        if (temCepePermissao) {
          this.resetaDesconto();
        }
      }
    },
  },
  components: { 'v-select': vSelect },
  data() {
    return {
      tipoDeCarteira: [
        { label: 'Selecione', id: null },
        { label: 'A', id: 'A' },
        { label: 'B', id: 'B' },
        { label: 'C', id: 'C' },
        { label: 'D', id: 'D' },
        { label: 'E', id: 'E' },
        { label: 'AB', id: 'AB' },
        { label: 'AC', id: 'AC' },
        { label: 'AD', id: 'AD' },
        { label: 'AE', id: 'AE' },
      ],
      tiposPessoas: [
        { label: 'Selecione', id: null },
        { label: 'Pessoa Física', id: 'Pessoa Física' },
        { label: 'Pessoa Jurídica', id: 'Pessoa Jurídica' },
      ],
      form: {
        idProposta: null,
        idProspect: null,
        tipo: null,
        nome: null,
        email: null,
        cpfcnpj: null,
        rgIe: null,
        dataNascimento: null,
        representanteLegal: null,
        cpfRepresentante: null,
        idRegional: null,
        telefone: null,
        celular: null,
        cnh: null,
        catCnh: null,
        dataVencimentoCnh: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        cpfDuplicado: false,
        unificaAssociado: false,
        associadoUnificado: null,
        celularAdicional: null,
      },
      cpf: null,
      formVerificaCpf: {},
      usaUF: true,
      isInterno: true,
      estado: null,
      cidade: null,
      estados: [],
      cidades: [],
      abrirSelectCidade: false,
      finalizouBuscaCep: false,
      alterouEstado: false,
      associadoUnificar: null,
      permissaoResetarDesconto: false,
    };
  },
  methods: {
    isCpfCanChange(permissao) {
      let retorno = true;
      if (this.form.situacao || this.form.idStatus) {
        retorno = false;
        if (permissao) retorno = permissao;
      }

      return retorno;
    },
    resetEndereco(novoValorEstado, valorAntigoEstado) {
      if (
        this.finalizouBuscaCep &&
        novoValorEstado != valorAntigoEstado.label &&
        this.alterouEstado == false
      ) {
        return;
      }

      this.form.cep = null;
      this.emitChangedForm('cep', this.form.cep);
      this.form.cidade = null;
      this.emitChangedForm('cidade', this.form.cidade);
      this.form.endereco = null;
      this.emitChangedForm('endereco', this.form.endereco);
      this.form.bairro = null;
      this.emitChangedForm('bairro', this.form.bairro);
      this.form.numero = null;
      this.emitChangedForm('numero', this.form.numero);
      this.form.complemento = null;
      this.emitChangedForm('complemento', this.form.complemento);
      this.form.estado = null;
      this.estado = null;
      this.emitChangedForm('estado', this.form.estado);

      document.querySelector('#cep').focus();
      this.finalizouBuscaCep = false;
      return;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitor: function () {
      if (this.form.cep.length == 10) {
        var cepbusca = this.form.cep.replace('.', '').replace('-', '');

        this.$vs.loading();
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.form.endereco = res.data.street;
            this.emitChangedForm('endereco', this.form.endereco);
            this.form.bairro = res.data.neighborhood;
            this.emitChangedForm('bairro', this.form.bairro);

            if (
              res.data.state != this.form.estado ||
              res.data.city != this.form.cidade
            ) {
              this.estado = res.data.state;
              this.form.estado = res.data.state;

              this.emitChangedForm('estado', this.form.estado);

              this.form.cidade = res.data.city;
              this.cidade = res.data.city;

              this.emitChangedForm('cidade', this.form.cidade);
            }

            this.finalizouBuscaCep = true;
            this.temCep = true;

            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      if (this.formulario.dadosCliente.idProposta) {
        this.form = this.formulario.dadosCliente;
        this.cpf = this.formulario.dadosCliente.cpfcnpj;
      } else {
        if (this.dadosProposta.idProposta) {
          this.form.idProposta = this.dadosProposta.idProposta;
          this.form.idProspect = this.dadosProposta.dadosCliente.idProspect;
          this.form.tipo = this.dadosProposta.dadosCliente.tipo;
          this.form.nome = this.dadosProposta.dadosCliente.associado;
          this.form.email = this.dadosProposta.dadosCliente.email;
          this.cpf = this.dadosProposta.dadosCliente.cpf;
          this.form.cpfcnpj = this.dadosProposta.dadosCliente.cpf;
          this.form.dataNascimento =
            this.dadosProposta.dadosCliente.dataNascimento;
          this.form.rgIe = this.dadosProposta.dadosCliente.rg_ie;
          this.form.cnh = this.dadosProposta.dadosCliente.cnh;
          this.form.catCnh = this.dadosProposta.dadosCliente.catCnh;
          this.form.dataVencimentoCnh =
            this.dadosProposta.dadosCliente.dataVencimentoCnh;
          this.form.representanteLegal =
            this.dadosProposta.dadosCliente.representanteLegal;
          this.form.cpfRepresentante =
            this.dadosProposta.dadosCliente.cpfRepresentante;
          this.form.idRegional = this.dadosProposta.dadosCliente.idRegional;
          this.form.telefone = this.dadosProposta.dadosCliente.telefone;
          this.form.celular =
            this.dadosProposta.dadosCliente.celular == null
              ? this.dadosProposta.dadosCliente.telefone
              : this.dadosProposta.dadosCliente.celular;

          this.form.cep = this.dadosProposta.dadosCliente.cep;
          this.temCep = this.dadosProposta.dadosCliente.cep ? true : false;

          this.form.endereco = this.dadosProposta.dadosCliente.endereco;
          this.form.numero = this.dadosProposta.dadosCliente.numero;
          this.form.complemento = this.dadosProposta.dadosCliente.complemento;
          this.form.bairro = this.dadosProposta.dadosCliente.bairro;

          this.cidade = this.dadosProposta.dadosCliente.cidade;
          this.form.cidade = this.dadosProposta.dadosCliente.cidade;

          if (
            this.dadosProposta.dadosCliente.estado &&
            this.dadosProposta.dadosCliente.estado.length == 2
          ) {
            const objEstado = this.estados.find(
              (estado) =>
                estado.label === this.dadosProposta.dadosCliente.estado,
            );

            this.estado = { id: objEstado.id, label: objEstado.label };
            this.form.estado = objEstado.label;

            this.buscaDadosSelectsCidades(
              'domMunicipio',
              'cidades',
              'nomeCidade',
              'idCidade',
            );
          }
          this.form.celularAdicional =
            this.dadosProposta.dadosCliente.celularAdicional;

          this.form.idStatus = this.dadosProposta.dadosCliente.idStatus;

          this.form.situacao = this.dadosProposta.dadosCliente.situacao;
        }
      }

      this.emitLoadedForm();
    },
    emitLoadedForm() {
      this.$emit('loaded', { formulario: 'dadosCliente', ...this.form });
      this.$validator.validateAll();
    },
    emitChangedForm(id, value) {
      this.$validator.validateAll();
      this.$emit('changed', {
        formulario: 'dadosCliente',
        id,
        value,
      });
    },

    selecionaEstado() {
      if (this.estado) this.form.estado = this.estado.label;
      else {
        this.estado = null;
        this.form.estado = null;
      }
      this.cidade = null;
      this.form.cidade = null;
      this.emitChangedForm('estado', this.form.estado);
      this.emitChangedForm('cidade', this.form.cidade);
    },

    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        return;
      }

      // const aux = this.cidades.find((x) => x.id == this.form.cidade.id);
      // this.form.cidade = aux.label;

      this.form.cidade = this.cidade.label;
      this.emitChangedForm('cidade', this.form.cidade);
    },

    buscaDadosSelectsEstados(model, array, campoDescricao, campoPK) {
      if (isValidCachedData(model)) {
        const cachedData = getFromCache(model);
        cachedData.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
        this[array].sort((a, b) => {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
        return;
      }

      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        saveToCache(model, res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort((a, b) => {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado || this.estado.label === 'EX' || !this.estado.id) {
        this[array] = [];
        this.cidade = null;
        this.$refs.selectCidade.open = false;
        return;
      }

      this[array] = [];
      if (this.estado && this.estado.id) {
        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then(({ data }) => {
            data = decryptData(data);

            if (data)
              data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });
          });

        if (this.abrirSelectCidade) {
          this.$refs.selectCidade.open = true;
          this.abrirSelectCidade = false;
        }
      }
    },
    verificaPermissaoResetarDesconto() {
      const permissao = this.$can(
        'Permite alterar endereço sem resetar desconto',
        'Cotações',
      );
      this.permissaoResetarDesconto = permissao;
    },

    resetaDesconto() {
      const { idProposta } = this.form;
      service.post('Cotacao', 'resetar-desconto', { idProposta });
    },
  },
  computed: {
    translatedRegional() {
      return this.$t('Regional');
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaDadosSelectsEstados('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaDadosSelectsCidades(
      'domMunicipio',
      'cidades',
      'nomeCidade',
      'idCidade',
    );
    this.verificaPermissaoResetarDesconto();
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}

hr.hr-endereco {
  color: grey;
  opacity: 0.4;
}
</style>
